/** @format */

/**
 * TNEW promo/source code tracking - if the 'promo' query param is present on a site URL, the param value is stored as a session cookie. 
 * If this cookie is present, the promo code is then appended to any TNEW URLs found on the site.
 */
const TNEW_URLS = ["https://basket.shakespearesglobe.com/", "https://sgth-tnew-prod.tnhs.cloud", "https://sgth-tnew-test.tnhs.cloud/"]
const TNEW_PROMO_CODE = getCookie('tnew_promo_code')
if (TNEW_PROMO_CODE && TNEW_PROMO_CODE.length) {
    document.querySelectorAll('a').forEach(anchor => {
        const href = anchor.href
        if (href.length && TNEW_URLS.some(url => href.startsWith(url))) {
            const urlObj = new URL(href)

            // initializing and updating URLSearchParams
            const params = new URLSearchParams(urlObj.search)
            params.set('premove', 'Y') // This is to allow for the switching of promo codes 
            params.set('promo', TNEW_PROMO_CODE)

            anchor.href = urlObj.origin + urlObj.pathname + '?' + params.toString()
        }
    })
}

/**
 * Retrieves a cookie value
 * @param {string} name - cookie name
 * @returns {string|null} cookie if found, otherwise `null`.
 */
function getCookie(name) {
    let cookie = document.cookie
        .split("; ")
        .find(row => row.startsWith(name + '='))

    return cookie ? cookie.split('=')[1] : null
}



// WEBPACK FOOTER //
// ./src/js/promo.js